import { render, staticRenderFns } from "./czmenu.vue?vue&type=template&id=082d1629&scoped=true&"
import script from "./czmenu.vue?vue&type=script&lang=ts&"
export * from "./czmenu.vue?vue&type=script&lang=ts&"
import style0 from "./czmenu.vue?vue&type=style&index=0&id=082d1629&scoped=true&lang=css&"
import style1 from "./czmenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082d1629",
  null
  
)

export default component.exports